<script setup lang="ts">
  import { FieldSearchBar } from '@/shared/ui';

  defineProps<{
    searchFields: { id: string; name: string }[];
    initialSearchTerm?: string;
  }>();

  const emit = defineEmits<{
    (e: 'search', queryString: string): void;
  }>();

  const handleSearch = (queryString: string) => {
    emit('search', queryString);
  };
</script>

<template>
  <div class="w-full">
    <FieldSearchBar
      class="w-full"
      :search-fields="searchFields"
      :initial-search-term="initialSearchTerm"
      @search="handleSearch"
    />
  </div>
</template>
